import React from 'react';

import { DrawerFooter as ChakraDrawerFooter } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';

export const DrawerFooter = ({ children, ...props }) => {
  const theme = useTheme();

  if (!children) return null;

  return (
    <ChakraDrawerFooter
      p={4}
      borderTopWidth="1px"
      h="72px"
      backgroundColor={theme.colors.neutral.F5F7F9}
      {...props}
      data-testid="bottom-drawer-footer"
    >
      {children}
    </ChakraDrawerFooter>
  );
};
